import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { getVideoFromUrl } from 'helpers'
import styled from 'styled-components'

import IconButton from 'js/components/IconButton/IconButton'
import Img from 'js/components/Img/Img'
import Modal from 'js/components/Modal/Modal'
import VideoModal from 'js/components/VideoModal'

import PlayIcon from 'icons/play.svg'

const Wrapper = styled.div`
    position: relative;
    background-color: white;
    height: 150px;
    border-top-left-radius: ${(p) => p.theme.radius.normal};
    border-top-right-radius: ${(p) => p.theme.radius.normal};
    overflow: hidden;

    /* Center play button */
    display: flex;
    justify-content: center;
    align-items: center;

    .FeedItemImageImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .FeedItemImageLink {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`

const FeedItemImage = ({ entity, ...rest }) => {
    const { t } = useTranslation()
    const location = useLocation()

    const [showVideoModal, setShowVideoModal] = useState(false)
    const toggleVideoModal = () => {
        setShowVideoModal(!showVideoModal)
    }

    const { url, featured } = entity
    const { image, alt, video, videoTitle, videoThumbnailUrl, positionY } =
        featured || {}

    const videoObject = !!video && getVideoFromUrl(video)

    return image || video ? (
        <Wrapper
            className="FeedItemImage" // Used in FeedItem
            {...rest}
        >
            <Img
                src={image?.download || videoThumbnailUrl}
                dimension={image?.download ? image?.dimension : null}
                objectFit="cover"
                objectPosition={`center ${Number.isFinite(positionY) ? `${positionY}%` : 'center'}`} // positionY = 0 is also a valid value
                alt={alt}
                className="FeedItemImageImg"
            />
            {url && (
                <Link
                    to={url}
                    state={{ prevPathname: location.pathname }}
                    className="FeedItemImageLink"
                    tabIndex="-1"
                    aria-hidden
                />
            )}
            {!!videoObject && (
                <>
                    <IconButton
                        variant="secondary"
                        size="normal"
                        dropShadow
                        onClick={toggleVideoModal}
                        aria-label={t('action.play-video')}
                    >
                        <PlayIcon />
                    </IconButton>
                    <Modal
                        isVisible={showVideoModal}
                        onClose={toggleVideoModal}
                        maxWidth="860px"
                        size="normal"
                        hideBackground
                        noPadding
                    >
                        <VideoModal
                            id={videoObject.id}
                            title={videoTitle}
                            type={videoObject.type}
                            onClose={toggleVideoModal}
                        />
                    </Modal>
                </>
            )}
        </Wrapper>
    ) : null
}

export default FeedItemImage
